import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { FactoryRouter } from './factoryRouter.js';
import { SocketConnection } from './socketConnection.js';
import '../contexts/TranslationContext.js';
import '../contexts/StoreContext.js';
import '../core/enums/GameSpecificTypes.js';
import '../core/enums/MaxPayoutDataTypes.js';
import '../core/enums/Chat.js';
import '../core/enums/GameModes.js';
import '../core/enums/IconTypes.js';
import '../core/enums/BetStatus.js';
import '../core/enums/PopupTypes.js';
import '../core/enums/ApiVersion.js';
import '../core/enums/RoundStatus.js';
import '../core/enums/FreeBetsStatus.js';
import '../core/enums/SocketEvents.js';
import '../core/enums/TranslationKeys.js';
import '../core/enums/TimeoutMaxValue.js';
import '../core/enums/ApiServiceTypes.js';
import '../core/enums/EnvironmentTypes.js';
import '../core/enums/DefaultQueryValues.js';
import '../core/enums/FreeBetWinningType.js';
import '../core/enums/DefaultQueryParams.js';
import '../core/enums/BetHistoryFilterTypes.js';
import '../core/enums/GameThemeTypes.js';
import '../core/enums/RequestStatus.js';
import '../core/enums/FetchDefaultPaths.js';
import '../core/enums/ResponseCodes.js';
import '../../_tslib-7a01aab4.js';
import '../../validateBalanceOnBet-af4f4a9b.js';
import 'mobx';
import '../core/classes/httpResponse/index.js';
import '@microsoft/signalr';
import '../core/services/liveConnection/types.js';
import '../core/store/chatStore.js';
import '../core/store/gameResultStore.js';
import '../core/enums/BogLineGameConfig.js';
import '../core/helpers/parseQuery.js';
import '../core/store/wageringStore.js';
import 'axios';
import '../core/store/roundInfoStore.js';
import '../core/store/userCountStore.js';
import '../core/enums/StatisticsSortingTypes.js';
import '../core/services/sound/types.js';
import '../core/services/sound/SoundService.js';
import 'howler';
import '../core/services/sound/defaultSounds.js';
import '../core/services/api/types.js';
import '../core/services/api/BaseApiService.js';
import '../core/store/resultHashStore.js';
import '../core/store/userWinBetsStore.js';
import '../core/store/notificationStore.js';
import '../core/store/selectedResultInfoStore.js';
import '../core/services/ApiServices.js';
import '../core/helpers/deepCopy.js';
import '../core/store/forCrashGame/inputValidationStore.js';
import '../core/store/forCrashGame/totalBetStore.js';
import '../core/store/forCrashGame/resultReportStore.js';
import '../core/store/forCrashGame/gameStore.js';
import '../core/polyfill.js';
import '../../_commonjsHelpers-17aad09c.js';
import '../../momentFormat-e9197995.js';
import '../../table-line/t_types/enums/BetResponseCode.js';
import '../../table-line/t_types/enums/BetErrorMessages.js';
import '../../table-line/t_types/enums/NotificationByResponseCode.js';
import '../../table-line/t_types/enums/FreeChipTypes.js';
import '../../table-line/t_types/enums/PopupTypes.js';
import '../core/helpers/formatDate.js';
import '../core/helpers/isMobile.js';
import '../core/enums/bogGameNames.js';
import '../core/helpers/updateHalfBets.js';

var Factory = function (_a) {
    var components = _a.components, liveConnection = _a.liveConnection, socketMethods = _a.socketMethods;
    return (React.createElement(BrowserRouter, null,
        React.createElement(SocketConnection, { liveConnection: liveConnection, socketMethods: socketMethods },
            React.createElement(FactoryRouter, { components: components }))));
};

export { Factory };
